import React from 'react'

import AddressInformation from './AddressInformation'
import BusinessContactInformation from './BusinessContactInformation'
import ClientReferencesInformation from './ClientReferencesInformation'
import ContactPersons from './ContactPersons'

const SecondPage = ({
  fields,
  selects,
  cityList,
  dynamicOptions,
  noVisibilityFilter,
  onTranslateAltRequest,
  onCountryChange,
  actionType,
  permissions,
  params,
  changeFormValue,
}) => (
  <>
    {/* @ts-ignore */}
    <AddressInformation
      noVisibilityFilter={noVisibilityFilter}
      fields={fields}
      selects={selects}
      cityList={cityList}
      onTranslateAltRequest={onTranslateAltRequest}
      onCountryChange={onCountryChange}
    />
    <hr />
    {/* @ts-ignore */}
    <BusinessContactInformation
      noVisibilityFilter={noVisibilityFilter}
      dynamicOptions={dynamicOptions}
      fields={fields}
      selects={selects}
      cityList={cityList}
      onTranslateAltRequest={onTranslateAltRequest}
      actionType={actionType}
      permissions={permissions}
      params={params}
      changeFormValue={changeFormValue}
      onCountryChange={onCountryChange}
    />
    <hr />
    {/* @ts-ignore */}
    <ClientReferencesInformation noVisibilityFilter={noVisibilityFilter} fields={fields} selects={selects} />
    <hr />
    {/* @ts-ignore */}
    <ContactPersons noVisibilityFilter={noVisibilityFilter} fields={fields} actionType={actionType} />
  </>
)

export default SecondPage
